import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Typography,
  TextField,
  Select,
  MenuItem,
  Button,
  InputLabel,
  FormControl,
  CircularProgress,
  Alert,
} from '@mui/material';
import { data, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FiSearch, FiUser, FiClock, FiCalendar } from 'react-icons/fi';
import { useSelector } from "react-redux";
import { apiHost } from '../../../utils/apiHost';
import { infoHariManual } from '../../../utils/rekapPresensi';

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const baseUrl = apiHost().replace(/^https?:\/\//, '');
  return `${protocol}://${baseUrl}`;
};

const AbsenManual = () => {
  const [tgl_absensi, setTanggalAbsensi] = useState('');
  const [jam_masuk, setJamMasuk] = useState('');
  const [jam_keluar, setJamKeluar] = useState('');
  const [karyawans, setKaryawans] = useState([]);
  const [userUuid, setKaryawan] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
   const { user } = useSelector((state) => state.auth);
  const endpoint = user?.role === "superadmin" ? "/getuser" : "/getusercabang";

  // Info jadwal & status hari yang dipilih (shift, libur, izin/sakit/cuti, absen yang sudah ada): hanya informasi.
  const [infoHari, setInfoHari] = useState(null);
  useEffect(() => {
    const k = karyawans.find((x) => x.uuid === userUuid);
    if (!k || !tgl_absensi) { setInfoHari(null); return undefined; }
    let batal = false;
    axios.get(`${getApiBaseUrl()}/absensi/kehadiran`, {
      params: { cabang: k.cabanguuid || k.Cabang?.uuid, dari: tgl_absensi, sampai: tgl_absensi, karyawan: userUuid },
      withCredentials: true,
    }).then((r) => { if (!batal) setInfoHari(infoHariManual(r.data?.data?.[0]?.hari?.[0])); })
      .catch(() => { if (!batal) setInfoHari(null); });
    return () => { batal = true; };
  }, [userUuid, tgl_absensi, karyawans]);

  useEffect(() => {
    const fetchData = async () => { 
      try {
        const response = await axios.get(`${getApiBaseUrl()}${endpoint}`);
        setKaryawans(Array.isArray(response.data.data) ? response.data.data : []);

        console.log(response.data)
      } catch (error) {
        setError('Gagal mengambil data karyawan.');
      }
    };
    fetchData();
  }, []);

 const filteredKaryawans = karyawans
  .filter((k) => k.role === 'karyawan')
  .filter((k) => k.username.toLowerCase().includes(searchTerm.toLowerCase()));


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userUuid || !jam_masuk || !jam_keluar || !tgl_absensi) {
      setError('Mohon lengkapi semua data absensi.');
      return;
    }

    setIsLoading(true);
    try {
      await axios.post(`${getApiBaseUrl()}/absensi/manual`, {
        userUuid,
        jam_masuk,
        jam_keluar,
        tanggal: tgl_absensi,
      });

      setMessage('Absensi berhasil dibuat');
      setTimeout(() => {
        navigate('/presensi');
      }, 1500);
    } catch (err) {
      setError(err.response?.data?.msg || err.response?.data?.message || 'Gagal menambah absensi.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box p={3}>
      <Card elevation={3}>
        <CardHeader title="Tambah Absensi Manual" />
        <CardContent>
          {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              fullWidth
              label="Cari Karyawan"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              margin="normal"
              InputProps={{
                startAdornment: <FiSearch style={{ marginRight: 8 }} />,
              }}
            />

            <FormControl fullWidth margin="normal" required>
              <InputLabel>Pilih Karyawan</InputLabel>
              <Select
                value={userUuid}
                onChange={(e) => setKaryawan(e.target.value)}
                label="Pilih Karyawan"
              >
                <MenuItem value="">Pilih Karyawan</MenuItem>
                {filteredKaryawans.length > 0 ? (
                  filteredKaryawans.map((karyawan) => (
                  <MenuItem key={karyawan.uuid} value={karyawan.uuid}>
  {`${karyawan.username} - ${karyawan.Cabang?.namacabang || 'Tanpa Cabang'}`}
</MenuItem>

                  ))
                ) : (
                  searchTerm && <MenuItem disabled>Tidak ada karyawan yang sesuai</MenuItem>
                )}
              </Select>
            </FormControl>

            {infoHari ? (
              <Alert severity={infoHari.tingkat} sx={{ mt: 1, mb: 1 }}>
                {infoHari.baris.map((t) => <div key={t}>{t}</div>)}
              </Alert>
            ) : null}

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="time"
                  label="Jam Masuk"
                  value={jam_masuk}
                  onChange={(e) => setJamMasuk(e.target.value)}
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="time"
                  label="Jam Keluar"
                  value={jam_keluar}
                  onChange={(e) => setJamKeluar(e.target.value)}
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>

            <TextField
              fullWidth
              type="date"
              label="Tanggal Absensi"
              value={tgl_absensi}
              onChange={(e) => setTanggalAbsensi(e.target.value)}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              required
            />

            <Box textAlign="center" mt={4}>
              <Button type="submit" variant="contained" disabled={isLoading}>
                {isLoading ? (
                  <>
                    <CircularProgress size={20} sx={{ mr: 1 }} /> Memproses...
                  </>
                ) : (
                  'Tambah Absensi'
                )}
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AbsenManual;
